<template>
  <div class="">
    <p class="favories-title">
      <i @click="$emit('cancelChose')" class="el-icon-arrow-right" style="cursor: pointer"></i>
      <span>产品收藏</span>
    </p>
    <div class="favories-wrap">
      <el-tabs v-model="tabActive" tab-position="top" @tab-click="changeTab">
        <el-tab-pane label="国家" name="0">
          <div v-loading="countryLoading" style="max-height: calc(100vh - 240px); overflow: auto;">
            <div v-for="(item, i) in countryList" :key="i" class="favorites-item">
              <div class="item-info">
                <img :src="item.picUrl || defaultIcon" alt="">
                <span>{{item.countryNamec}}</span>
              </div>
              <div class="check-button" @click="checkPrice(item)">查看</div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="线路产品" name="1">
          <div v-loading="lineProductLoading" style="max-height: calc(100vh - 240px); overflow: auto;">
            <div v-for="(item, i) in lineProductList" :key="i" class="favorites-item">
              <div class="item-info">
                <span>{{item.productName}}</span>
              </div>
              <div class="check-button" @click="checkDetails(item)">查看</div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
     <!-- 查看详情 -->
     <!-- <el-dialog width="1200px" :visible.sync="ProgType" :close-on-click-modal="false" :append-to-body="true">
      <GetitemBill
        v-if="ProgType"
        :countData="countData"
        :theadData="theadData"
        :tableData="tableData"
        :deliveryTheadData="deliveryTheadData"
        :deliveryTableData="deliveryTableData"
        :BillItem="BillItem"
        :payType="payType"
        :type="ProgType"
        :val="typeTips"
        @getProductData="getFavoritesLineProduct"
      ></GetitemBill>
    </el-dialog> -->
    <!-- 查价详情-->
    <line-product-detail
      :visible.sync="ProgType"
      :countData="countData"
      :theadData="theadData"
      :tableData="tableData"
      :deliveryTheadData="deliveryTheadData"
      :deliveryTableData="deliveryTableData"
      :BillItem="BillItem"
      :payType="payType"
      :type="ProgType"
      :val="typeTips"
      :podlandType="countData.isFBA ? 1 : 2"
      :is-transfer="!!BillItem.domDTO"
    ></line-product-detail>
  </div>
</template>

<script>
import GetitemBill from "@/components/placeOrder/placeindexInfo/GetitemBill.vue"
import lineProductDetail from "@/components/placeOrder/placeindexInfo/lineProductDetail.vue"
import {sendCustomerOperationRecord,sendStatisticHotCountry} from "@/assets/js/utils";
import {ossPath} from "../../devParams"
import { mapState } from "vuex"
export default {
  name: 'favorites',
  components: { GetitemBill, lineProductDetail },
  data() {
    return {
      defaultIcon: ossPath + "/pages/home/hot_country_default_icon.png",
      tabActive: '0',
      countryLoading: false,
      lineProductLoading: false,
      countryList: [],
      lineProductList: [],
      tableData: [],
      countData: {},
      theadData: [],
      deliveryTheadData: [],
      deliveryTableData: [],
      BillItem: {},
      payType: false,
      ProgType: false,
      typeTips: 2, //
    }
  },
  created() {
    if (this.Authorization && this.Authorization.token) this.getFavoritesCountry()
    this.$root.Bus.$on("refreshFavoritesCountry", () => {
      this.getFavoritesCountry()
    })
    this.$root.Bus.$on("refreshFavoritesLineProduct", () => {
      this.getFavoritesLineProduct()
    })
  },
  computed: {
    ...mapState(["Authorization"])
  },
  methods: {
    changeTab(val) {
      console.log(val.index)
      if (val.index === '0') {
        if (this.Authorization && this.Authorization.token) this.getFavoritesCountry()
      } else if (val.index === '1') {
        if (this.Authorization && this.Authorization.token) this.getFavoritesLineProduct()
      }
    },
    checkPrice(val) {
      const route = this.$route
      const item = {
        ...val,
        fromSelectId: [null, val.cityId],
        toSelectId: [val.countryId, ''],
        isPrivateAddress: false,
        privateAddressType: val.privateAddressType,
        opening: true,
        fromCityInfo: {
          namec: val.cityNamec,
          code: val.cityCode
        }
      }
      if (!val.cityId) return this.$message.warning('缺少起运地参数')
      if (!val.countryId) return this.$message.warning('缺少目的地参数')
      if (!val.privateAddressType) return this.$message.warning('缺少目的地私人地址类型参数')
      if (route.name === 'queryPrice') {
        this.$root.Bus.$emit('toolsQuery', item, false)
      } else {
        // 带参数跳转至专线大厅
        // const item = {
        //   ...val,
        //   fromSelectId: [null, val.cityId],
        //   toSelectId: [val.countryId, ''],
        //   isPrivateAddress: false,
        //   opening: true,
        //   fromCityInfo: {
        //     namec: val.cityNamec,
        //     code: val.cityCode
        //   }
        // }
        this.$router.push({
          name: "queryPrice",
          query: {
            itemData: JSON.stringify(item),
            type: false,
            name: '收藏国家'
          },
        })
      }
      sendStatisticHotCountry(val.cityCode || '',val.countryCodecode || '')
      this.$emit('cancelChose')
    },
    checkDetails (item, type, val) {
      console.log("item---", item)
      this.typeTips = val
      this.payType = type
      sendCustomerOperationRecord("查看详情",`产品名称:${item.productName}`, { productId: item.productId })
      if (item.polCityCode || item.countryCode) sendStatisticHotCountry(item.polCityCode || '', item.countryCode || '') // 热门国家城市埋点
      let url = ""
      url = `/FBAfee/queryQuotedPriceDetailInfo?productPriceHeaderId=${item.productPriceHeaderId}`
      this.axios
        .get(url)
        .then((res) => {
          if (res.data.code === 200) {
            this.ProgType = true
            this.countData = res.data.data || {}
            let labelList = [
              { label: item.pickUpFlag ? '免费上门提货' : '', desc: '' },
              { label: item.goodsMeasurementMethod === 1 ? '机器量方' : '皮尺量方', desc: '' },
              { label: item.whetherSupportedCompensate ? '时效赔付' : '', desc: item.supportedCompensateDesc || item.compensationStandards },
              { label: item.whetherSupportCompensation ? '丢货赔付' : '不支持丢货赔付', desc: item.supportCompensationDesc || item.compensationStandards },
              { label: item.whetherGuaranteedDelivery ? '限时达' : '', desc: '' },
              { label: item.label1, desc: item.label1Desc },
              { label: item.label2, desc: item.label2Desc },
              { label: item.label3, desc: item.label3Desc },
            ]
            labelList = labelList.filter(v => v.label)
            item.labelList = labelList
            this.countData = {
              ...this.countData,
              carrierLogoUrl: item.carrierLogoUrl,
              carrierAbbr: item.carrierAbbr,
              labelList: item.labelList,
              aging: item.aging,
              agingType: item.agingType
            }
            this.BillItem = res.data.data || {}
            console.log("this.BillItem: ", this.BillItem)
            this.getAttr()
            this.setDeliveryPrices()
          } else {
            this.$message.error(res.data.message)
          }
        })
        .catch((res) => { })
    },
    getAttr () {
      this.theadData = this.countData.productRegionPrices[0].map((c, i) => {
        return {
          label: c,
          prop: "name" + i,
        }
      })
      console.log("99999---", this.theadData)
      let tableData = []
      this.countData.productRegionPrices.forEach((item, index) => {
        let obj = {}
        item.map((_item, index) => {
          obj["name" + index] = _item
        })
        tableData.push(obj)
      })
      this.tableData = tableData
      this.tableData.splice(0, 1)
      console.log("tableData", this.tableData)
    },
    setDeliveryPrices() {
      // deliveryRegionPrices
      if (!this.countData.deliveryRegionPrices) {
        this.deliveryTheadData = []
        this.deliveryTableData = []
        return false
      }
      this.deliveryTheadData = this.countData.deliveryRegionPrices[0].map((c, i) => {
        return {
          label: c,
          prop: "name" + i,
        };
      });
      console.log("99999---", this.deliveryTheadData);
      let tableData = [];
      let list = this.countData.deliveryRegionPrices.map(item => item)
      list.splice(0, 1)
      // this.sortQuotationList(list);
      list.forEach((item, index) => {
        let obj = {};
        item.map((_item, index) => {
          obj["name" + index] = _item;
        });
        tableData.push(obj);
      });
      this.deliveryTableData = tableData;
      // this.deliveryTableData.splice(0, 1);
      console.log("tableData", this.deliveryTableData);
    },
    getFavoritesCountry() {
      this.countryLoading = true
      this.axios
        .get("/api/product/queryConcernCountryPriceInfo")
        .then((res) => {
          this.countryLoading = false
          if (res.data.code == 200) {
            this.countryList = res.data.datas
          }
        })
        .catch((res) => {
          this.countryLoading = false
        })
    },
    getFavoritesLineProduct() {
      this.lineProductLoading = true
      console.log("this.concernTime-----------------------------")
      this.axios
        .get(
          `/api/product/queryConcernProductPriceInfo`
        )
        .then((res) => {
          this.lineProductLoading = false
          if (res.data.code == 200) {
            this.lineProductList = res.data.datas
          }
        })
        .catch((res) => {
          this.lineProductLoading = false
          // this.$message.info("服务器繁忙");
        })
    }
  }
}
</script>

<style lang="scss">
.favories-title {
  padding-top: 150px;
  padding-left: 18px;
  line-height: 30px;
  font-size: 18px;
  font-weight: bold;
  i {
    font-weight: bold;
    &:hover {
      color: #FF4D01
    }
  }
}
.favories-wrap {
  padding: 0 20px;
  .el-tabs__nav-wrap::after {
    display: none;
  }
}
.favorites-item {
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 18px;
  background: #FFFFFF;
  border-radius: 5px;
  line-height: 30px;
  .item-info img {
    width: 30px;
    vertical-align: middle;
    margin-right: 6px;
  }
  .check-button {
    width: 60px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    color: #FFFFFF;
    background: #FF4D01;
    border-radius: 5px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// common/toolBar/favorites.vue